import { AfterViewInit, Component, ElementRef, Inject, inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import SignaturePad from 'signature_pad';
import { AlertService } from 'src/app/services/alert.service';

@Component({
	selector: 'app-signature',
	template: `
		<h1 mat-dialog-title class="title" dir="rtl">חתימה</h1>
		<div class="popup__signature-fullscreen__wrapper">
			<canvas class="signature-canvas" #signature width="270" (mousedown)="signatureOK = true" (pointerdown)="signatureOK = true"></canvas>
			<button class="order-step__block-button" (click)="finalizeSignature()" [ngClass]="{ 'order-step__block-button_green': signatureOK }">אשר חתימה</button>
			<button class="order-step__block-button order-step__block-button_red" (click)="forgetAndClosePopup()">שכח</button>
		</div>
	`,
	styleUrls: ['./signature.component.scss'],
})
export class SignatureComponent implements AfterViewInit {
	private matDialogRef = inject(MatDialogRef);
	private _alert = inject(AlertService);

	isSignaturePopupOpen = false;
	signatureOK = false;

	signatureFinalized = false;

	signaturePad: SignaturePad | undefined;

	constructor(@Inject(MAT_DIALOG_DATA) private data: { signature: string }) {}

	@ViewChild('signature') signatureCanvas: ElementRef<HTMLCanvasElement> | undefined;

	ngAfterViewInit(): void {
		this.setupSignaturePad();
	}

	finalizeSignature() {
		if (!this.signatureOK) return;
		this.signatureFinalized = true;
		this.toggleSignaturePopupAndPrepareSignatureCanvas();
	}

	forgetAndClosePopup() {
		this.signatureOK = this.signatureFinalized = false;
		this.closePopup();
	}

	async toggleSignaturePopupAndPrepareSignatureCanvas() {
		if (this.signatureFinalized) {
			const confirmation = await this._alert.customConfirmAlert('האם להמשיך עם חתימה זו?');
			if (confirmation) {
				this.closePopup();
			}
			return;
		}
		this.signatureOK = this.signatureFinalized = false;
		this.closePopup();
		return;
	}

	setupSignaturePad() {
		const canvas = this.signatureCanvas?.nativeElement;

		if (!canvas) {
			this.isSignaturePopupOpen = false;
			return;
		}
		this.signaturePad = new SignaturePad(canvas, {
			backgroundColor: 'white',
		});

		const ctx = canvas.getContext('2d');
		if (!ctx) return;

		if (this.data.signature) {
			this.signaturePad
				.fromDataURL(this.data.signature, {
					width: 270,
					height: 150,
				})
				.then(() => {
					this.signatureOK = true;
				});
		}

		ctx.strokeStyle = '#BADA55';
		ctx.lineJoin = 'round';
		ctx.lineCap = 'round';
	}

	closePopup() {
		if (this.signatureOK) {
			this.matDialogRef.close(this.signaturePad?.toDataURL() || '');
			return;
		}
		this.matDialogRef.close();
	}
}
